"use strict";

var _slicedToArray = require("/vercel/path0/react/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var util_1 = require("./util");

var defaultState = {
  angle: 0,
  type: 'landscape-primary'
};

var useOrientation = function useOrientation() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;

  var _react_1$useState = react_1.useState(initialState),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      state = _react_1$useState2[0],
      setState = _react_1$useState2[1];

  react_1.useEffect(function () {
    var mounted = true;

    var onChange = function onChange() {
      if (mounted) {
        var _screen = screen,
            orientation = _screen.orientation;

        if (orientation) {
          var angle = orientation.angle,
              type = orientation.type;
          setState({
            angle: angle,
            type: type
          });
        } else if (window.orientation) {
          setState({
            angle: typeof window.orientation === 'number' ? window.orientation : 0,
            type: ''
          });
        } else {
          setState(initialState);
        }
      }
    };

    util_1.on(window, 'orientationchange', onChange);
    onChange();
    return function () {
      mounted = false;
      util_1.off(window, 'orientationchange', onChange);
    };
  }, [0]);
  return state;
};

exports.default = useOrientation;